import { useMemo } from 'react';

import type { ChatId, Topic } from 'pages/ParentHelper/types';

export const useShouldScrollToTodaySection = (
  chatTopics: Topic[],
  chatId: ChatId,
) =>
  useMemo(
    () =>
      !chatTopics.find(topic => topic.chatId === chatId)?.isFavorite || false,
    [chatTopics, chatId],
  );
